import { render, staticRenderFns } from "./Minimal.vue?vue&type=template&id=5edbe09c"
import script from "./Minimal.vue?vue&type=script&lang=js"
export * from "./Minimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edbe09c')) {
      api.createRecord('5edbe09c', component.options)
    } else {
      api.reload('5edbe09c', component.options)
    }
    module.hot.accept("./Minimal.vue?vue&type=template&id=5edbe09c", function () {
      api.rerender('5edbe09c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/Minimal.vue"
export default component.exports